const critical_Fields = [];

critical_Fields.push({
    key: 'VoluntaryExit',
    criticalFields: [
        'nationalityType.id',
        'globalRank.rankCode',
        'exitSubType.id',
        'officeLocation.id',
        'subServiceLine.id',
        'serviceLine.id',
        'job.rank',
        'nationality'
    ]
},
{
    key: 'InvoluntaryExit',
    criticalFields: [
        'exitSubType.id',
        'nationalityType.id',
        'officeLocation.id',
    ]
},
{
    key: 'InternExit',
    criticalFields: [
        'officeLocation.id',
    ]
},
)

Object.freeze(critical_Fields);

export { critical_Fields };